module.exports = __webpack_public_path__ + "assets/img/18_183_big.db6a25f9.jpg";